<template>
  <b-modal ref="add-tipo-acuerdo-modal" hide-footer no-close-on-backdrop @hidden="onlyClose" :title="modalTitle">
    <template #default>
      <validation-observer ref="form">
        <b-row>
          <!-- Nombre -->
          <b-col lg="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group :label="$t('Nombre')">
                <b-form-input v-model="form.nombre" :class="{ 'border-danger': errors[0] }"
                  placeholder="Ej: 28 x 2, 26 x 4" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Descripción -->
          <b-col lg="12">
            <validation-provider v-slot="{ errors }">
              <b-form-group :label="$t('Descripción')">
                <b-form-input v-model="form.descripcion" :class="{ 'border-danger': errors[0] }"
                  placeholder="Breve descripción del régimen" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Modo de calculo de la meta mensual -->
          <b-col lg="12">
            <b-form-group :label="$t('Cómo se calculan los días libres del mes')">
              <b-form-select v-model="form.modo_calculo" :options="modosCalculo" />
              <small class="text-muted">{{ ayudaModo }}</small>
            </b-form-group>
          </b-col>

          <!-- Días Libres Mensuales (modo fijo) -->
          <b-col lg="12" v-if="form.modo_calculo === 'fijo'">
            <validation-provider v-slot="{ errors }" rules="required">
              <b-form-group :label="$t('Días Libres Mensuales')">
                <b-form-input type="number" v-model.number="form.dias_libres_mensuales" :class="{ 'border-danger': errors[0] }" />
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Ciclo de trabajo / descanso -->
          <template v-if="form.modo_calculo === 'ciclo'">
            <b-col lg="6">
              <validation-provider v-slot="{ errors }" rules="required">
                <b-form-group :label="$t('Días de trabajo')">
                  <b-form-input type="number" v-model.number="form.dias_trabajo" :class="{ 'border-danger': errors[0] }" placeholder="Ej: 28" />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col lg="6">
              <validation-provider v-slot="{ errors }" rules="required">
                <b-form-group :label="$t('Días de descanso')">
                  <b-form-input type="number" v-model.number="form.dias_descanso" :class="{ 'border-danger': errors[0] }" placeholder="Ej: 2" />
                </b-form-group>
              </validation-provider>
            </b-col>
          </template>

          <!-- Prorrateo -->
          <b-col lg="12">
            <b-form-checkbox v-model="form.prorratea" switch>
              Prorratear la meta en el mes de ingreso y en el de cese
            </b-form-checkbox>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end mt-2" style="width: 100%">
          <b-button variant="outline-danger" size="sm" @click="onlyClose">
            {{ $t("close") | capitalize }}
          </b-button>
          <b-button variant="outline-primary" class="ml-1" @click="submitForm">
            {{ method == "create" ? $t("save") : $t("edit") | capitalize }}
          </b-button>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import TiposAcuerdosService from "./service/tipos-acuerdos.service.js";
import { mapGetters } from "vuex";

export default {
  props: {
    item: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    method: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    ayudaModo() {
      if (this.form.modo_calculo === "domingos_mes") {
        return "Meses con 5 domingos otorgan 5 días; los de 4 domingos, 4.";
      }
      if (this.form.modo_calculo === "ciclo") {
        return "La meta sale de los días del mes por la proporción de descanso del ciclo.";
      }
      return "Todos los meses otorgan la misma cantidad de días libres.";
    },
    modalTitle() {
      return this.method === "create"
        ? 'Agregar Tipo de Acuerdo'
        : 'Editar Tipo de Acuerdo';
    },
  },
  data() {
    return {
      form: {
        id: null,
        nombre: "",
        descripcion: "",
        dias_libres_mensuales: 0,
        modo_calculo: "fijo",
        dias_trabajo: null,
        dias_descanso: null,
        prorratea: true,
      },
      modosCalculo: [
        { value: "fijo", text: "Cantidad fija de días al mes" },
        { value: "domingos_mes", text: "Los domingos reales de cada mes" },
        { value: "ciclo", text: "Proporcional al ciclo trabajo / descanso" },
      ],
    };
  },
  mounted() {
    this.toggleModal("add-tipo-acuerdo-modal");
    if (this.method === "edit" && this.item) {
      this.form = {
        id: this.item.id,
        nombre: this.item.nombre,
        descripcion: this.item.descripcion || "",
        dias_libres_mensuales: parseInt(this.item.dias_libres_mensuales) || 0,
        modo_calculo: this.item.modo_calculo || "fijo",
        dias_trabajo: this.item.dias_trabajo || null,
        dias_descanso: this.item.dias_descanso || null,
        prorratea: this.item.prorratea === undefined ? true : !!Number(this.item.prorratea),
      };
    }
  },
  methods: {
    onlyClose() {
      this.$emit("close");
    },
    async submitForm() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      try {
        this.addPreloader();
        const params = {
          ...this.form,
          user_id: this.currentUser ? this.currentUser.id : null,
        };

        const data = await TiposAcuerdosService.createOrUpdate(params);
        this.showToastSuccess(data.message);
        this.$emit("saved");
      } catch (error) {
        console.error(error);
        this.showToastError(error?.response?.data?.message || error.message);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>
